import React, { useEffect, useState } from 'react'
import './App.css'
import Header from './components/new-header/demo-header'
import Body from './components/body/body'
import particle_component from './components/particle-component';
import Projects from './components/projects/projects'
import Skills from './components/skills/skills'
import Contact from './components/contact/contact'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import About from './components/about/about';
import card from './components/about/work_experience/card'
import Footer from './components/footer/footer'

import * as location from "./Animations/Aeroplane_Loading.json"
import * as success from "./Animations/Success.json"
import Lottie from 'react-lottie'


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}


const defaultOptions1 = {
  loop: true,
  autoplay: true,
  animationData: location.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions2 = {
  loop: true,
  autoplay: true,
  animationData: success.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function PreLoader2() {
  const [data, setData] = useState([]);
  const [loading, setloading] = useState(undefined);
  const [completed, setcompleted] = useState(undefined);

  useEffect(() => {
    setTimeout(() => {
      fetch("https://jsonplaceholder.typicode.com/posts")
        .then((response) => response.json())
        .then((json) => {
          setData(json);
          setloading(true);

          setTimeout(() => {
            setcompleted(true);
          }, null);
          // Change the above val to shorten the animation time
        });
    }, 2000);
  }, []);
  const { height, width } = useWindowDimensions();


  // New rendering with 1 loading screen
  return <div>{
    !loading ? <Lottie options={defaultOptions1} height={height} width={width} />
      :
      <>
        <div className="headline">
          <Header />
          <Router>
            <Switch>
              <Route exact path="/" component={body_components} />
              <Route exact path="/about" component={about_components} />
            </Switch>
          </Router>
          <Footer />
        </div>
      </>
  }</div>;

  // Old rendering with 2 loading screens
  // return (
  //   <>
  //     {!completed ? (
  //       <>
  //         {!loading ? (
  //           <Lottie options={defaultOptions1} height={height} width={width} />
  //         ) : (
  //           <Lottie options={defaultOptions2} height={height} width={width} />
  //         )}
  //       </>
  //     ) : (
  // <>
  //   <div className="headline">
  //     <Header />
  //     <Router>
  //       <Switch>
  //         <Route exact path="/" component={body_components} />
  //         <Route exact path="/about" component={about_components} />
  //       </Switch>
  //     </Router>
  //     <Footer />
  //   </div>
  // </>
  //     )}
  //   </>
  // );
}


function body_components() {
  return <div className="App container mx-10 mx-auto max-w-screen-lg container bg-gray-800">
    <Body />
    <Projects />
    <Skills />
    <Contact />
    {/* <particle_component/> */}
  </div>
}

function about_components() {
  return <div className="App container mx-10 mx-auto max-w-screen-lg container bg-gray-800">
    {/* <particle_component/> */}
    <About />
  </div>
}

function App() {
  return (
    <div>
      <Header />
      <Router>
        <Switch>
          <Route exact path="/" component={body_components} />
          <Route exact path="/about" component={about_components} />
        </Switch>
      </Router>
      <Footer />
    </div>
  )
}

export default PreLoader2


// onClick={() => window.scroll(0, 0)}